<template>
  <div
    id="configuration-modal"
    class="modal"
    role="dialog"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('hide-modal')">
            &times;
          </button>
          <h4 class="modal-title text-left">
            <i class="fa fa-sliders" aria-hidden="true"></i> Configure Fabric
          </h4>
        </div>
        <div class="modal-body bg-white">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Supplier Code</label>
                <div class="col-sm-9">
                  <input
                    type="text"
                    v-model="modelValues.defaults.current_fabric_supplier_code"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Width</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="modelValues.defaults.default_width"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Unit Price</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="modelValues.unit_price"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Currency</label>
                <div class="col-sm-7">
                  <v-select
                    :options="['THB', 'USD']"
                    v-model="modelValues.currency"
                    placeholder="Choose Currency"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Vat</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    class="form-control"
                    v-model="modelValues.defaults.default_vat_per_unit"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Unit</label>
                <div class="col-sm-7">
                  <v-select
                    placeholder="Choose One"
                    v-model="modelValues.unit"
                    :reduce="(unit) => unit.value"
                    :options="[
                      { value: 'm', label: 'Meter' },
                      { value: 'y', label: 'Yard' },
                      { value: 'kg', label: 'Kilogram' },
                    ]"
                    :clearable="false"
                    label="label"
                    class="unit"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Total Unit Price</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    class="form-control disabled"
                    disabled=""
                    v-model="modelValues.defaults.default_unit_price_total"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <br />
          <div class="form-group row" v-if="$auth.user().role === 'admin'">
            <label for="inputEmail3" class="col-sm-2 col-form-label"
              >Fiber 1</label
            >
            <div class="col-sm-4">
              <v-select
                :options="fieldValues.fibers"
                v-model="modelValues.defaults.fiber_1"
                placeholder="Choose One"
              />
              <div v-if="showFiberError" class="fiber_error">Fiber 1 can't be empty</div>
            </div>
            <div class="col-md-4 slider-container">
              <vue-slider
                v-model="modelValues.defaults.fiber_1_percentage"
                :min="0"
                :max="100"
              />
            </div>
            <div class="col-md-2">
              <input
                type="text"
                v-model="modelValues.defaults.fiber_1_percentage"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row" v-if="$auth.user().role === 'admin'">
            <label for="inputEmail3" class="col-sm-2 col-form-label"
              >Fiber 2</label
            >
            <div class="col-sm-4">
              <v-select
                :options="fieldValues.fibers"
                v-model="modelValues.defaults.fiber_2"
                placeholder="Choose One"
              />
            </div>
            <div class="col-md-4 slider-container">
              <vue-slider
                v-model="modelValues.defaults.fiber_2_percentage"
                :min="0"
                :max="100"
              />
            </div>
            <div class="col-md-2">
              <input
                type="text"
                v-model="modelValues.defaults.fiber_2_percentage"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row" v-if="$auth.user().role === 'admin'">
            <label for="inputEmail3" class="col-sm-2 col-form-label"
              >Fiber 3</label
            >
            <div class="col-sm-4">
              <v-select
                :options="fieldValues.fibers"
                v-model="modelValues.defaults.fiber_3"
                placeholder="Choose One"
              />
            </div>
            <div class="col-md-4 slider-container">
              <vue-slider
                v-model="modelValues.defaults.fiber_3_percentage"
                :min="0"
                :max="100"
              />
            </div>
            <div class="col-md-2">
              <input
                type="text"
                v-model="modelValues.defaults.fiber_3_percentage"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="inputEmail3" class="col-sm-2 col-form-label"
              >Composition label</label
            >
            <div class="col-sm-6">
              <v-select
                :options="fieldValues.formattedCompositionLabels"
                v-model="modelValues.defaults.fabric_composition_label_id"
                placeholder="Choose One"
                label="name"
                :reduce="(compositionLabel) => compositionLabel.id"
              />
            </div>
          </div>

          <div class="line"></div>
          <br />
          <br />
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Yarn Count</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="modelValues.defaults.default_yarn_count"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Coloring Style</label>
                <div class="col-sm-7">
                  <v-select
                    :options="fieldValues.coloringStyles"
                    v-model="modelValues.defaults.default_coloring_style"
                    placeholder="Choose One"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Density</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="modelValues.defaults.default_density"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Finish</label>
                <div class="col-sm-7">
                  <v-select
                    :options="fieldValues.finishes"
                    v-model="modelValues.defaults.default_finish"
                    placeholder="Choose One"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Stretch</label>
                <div class="col-sm-7">
                  <select
                    class="form-control"
                    v-model="modelValues.defaults.is_stretch_fabric"
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Jersey</label>
                <div class="col-sm-7">
                  <select
                    class="form-control"
                    v-model="modelValues.defaults.is_jersey_fabric"
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Weight</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    class="form-control"
                    v-model="modelValues.defaults.default_weight"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label"
                  >Interlining</label
                >
                <div class="col-sm-7">
                  <select
                    class="form-control"
                    v-model="modelValues.defaults.interlining"
                  >
                    <option v-for="interlining in fieldValues.interlinings" :value="interlining.code">{{ interlining.code }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label">Certificate</label>
                <div class="col-sm-7">
                  <v-select
                    placeholder="No certificate"
                    v-model="modelValues.defaults.certificate"
                    :options="fieldValues.certificates"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-5 col-form-label"
                  >Special characteristic</label
                >
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="modelValues.defaults.special_description_suffix"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer bg-white">
          <div class="row">
            <div class="col-md-12">
              <button
                class="btn btn-block btn-success"
                @click="saveOverrides()"
                v-if="!isReadOnlyUser"
                :disabled="showFiberError"
              >
                Save Configuration
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
export default {
  components: {
    VueSlider,
  },
  watch: {
    "modelValues.defaults.fiber_1": {
      handler(newValues, oldValues) {
        if(this.modelValues.defaults.fiber_1 === null) {
          this.showFiberError = true;
        } else {
          this.showFiberError = false;
        }
      }
    },
    "modelValues.unit_price": {
      handler(newValues, oldValues) {
        let unitPrice = parseFloat(this.modelValues.unit_price);
        let vatPerUnit = parseFloat(
          this.modelValues.defaults.default_vat_per_unit
        );
        this.modelValues.defaults.default_unit_price_total = !isNaN(vatPerUnit)
          ? (
              parseFloat(this.modelValues.unit_price) +
              parseFloat(this.modelValues.defaults.default_vat_per_unit)
            ).toFixed(2)
          : parseFloat(this.modelValues.defaults.default_unit_price);
      },
    },
    "modelValues.defaults.default_vat_per_unit": {
      handler(newValues, oldValues) {
        let unitPrice = parseFloat(this.modelValues.unit_price);
        let vatPerUnit = parseFloat(
          this.modelValues.defaults.default_vat_per_unit
        );
        this.modelValues.defaults.default_unit_price_total = !isNaN(unitPrice)
          ? (
              parseFloat(this.modelValues.unit_price) +
              parseFloat(this.modelValues.defaults.default_vat_per_unit)
            ).toFixed(2)
          : parseFloat(this.modelValues.defaults.default_vat_per_unit);
      },
    },
    "order.invoice_currency": {
      handler(newValues, oldValues) {
        let unitPrice = parseFloat(this.modelValues.unit_price);
        let vatPerUnit = parseFloat(
          this.modelValues.defaults.default_vat_per_unit
        );
        this.modelValues.defaults.default_unit_price_total = !isNaN(unitPrice)
          ? (
              parseFloat(this.modelValues.unit_price) +
              parseFloat(this.modelValues.defaults.default_vat_per_unit)
            ).toFixed(2)
          : parseFloat(this.modelValues.defaults.default_vat_per_unit);
      },
    },
  },
  mounted() {
    if(this.modelValues.defaults.fiber_1 === null) {
      this.showFiberError = true;
    }
    this.mergeValues(this.modelValues.defaults, this.modelValues.overrides);
  },
  data: function () {
    return {
      fabric: {},
      fibers: [
        "fiber_1",
        "fiber_1_percentage",
        "fiber_2",
        "fiber_2_percentage",
        "fiber_3",
        "fiber_3_percentage",
      ],
      showFiberError: false
      // overrideFabricComposition: true,
    };
  },
  props: {
    fieldValues: {
      type: [Object],
      default: null,
    },
    modelValues: {
      type: [Object],
      default: null,
    },
    errors: {
      type: [Array, Object],
      default: null,
    },
    order: {
      type: [Array, Object],
      default: null,
    },
    isReadOnlyUser: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    mergeValues(defaultValues, overridenValues) {
      this.fabric = { ...{}, ...defaultValues };
      for (var key in overridenValues) {
        this.fabric[key] =
          overridenValues[key] !== null
            ? overridenValues[key]
            : this.fabric[key];
      }
    },
    saveOverrides() {
      // compare this.fabric values vs default values
      let changeSetOne = {};
      for (var key in this.fabric) {
        if (this.fabric[key] !== this.modelValues.defaults[key]) {
          changeSetOne[key] = this.modelValues.defaults[key];
        }
      }

      // compare the changed values vs overriden values
      let changeSetTwo = {};
      for (var key in changeSetOne) {
        if (changeSetOne[key] !== this.modelValues.overrides[key]) {
          changeSetTwo[key] = changeSetOne[key];
        }
      }

      // emit the changes back to the parent component
      this.$emit("component-updated", changeSetTwo, this.fabric);
    },
  },
};
</script>
<style scoped>
.modal-header .close {
  margin-top: -4px !important;
  font-size: 30px;
}
.fiber_error {
  color: red;
  margin-top: 7px;
}
</style>
